import { ConfigType } from 'store/api/config/types';
import config from '../mock/config.json';

export const useConfigData = (): { data: ConfigType } => {
  return { data: config as unknown as ConfigType };
};
